/**
 * CreditNotes API - Auto-generated typed wrapper.
 * DO NOT EDIT - Regenerate with: bun run generate
 * @generated
 */

import {
  createCreditNote,
  createCustomCreditNote,
  getCreditNoteById,
  getCreditNotes,
  getCreditNoteVersion,
  getCreditNoteVersions,
  getShareableCreditNote,
  getShareableCreditNoteEslog,
  getShareableCreditNoteHtml,
  getShareableCreditNotePdf,
  renderCreditNotePreview,
  updateCreditNote,
  voidCreditNote,
} from "../generated/credit-notes/credit-notes";

import { wrapListMethod, wrapMethod } from "./utils";

export const creditNotes = {
  /** @see getShareableCreditNote */
  getShareableCreditNote: wrapMethod(getShareableCreditNote),

  /** @see getShareableCreditNoteHtml */
  getShareableCreditNoteHtml: wrapMethod(getShareableCreditNoteHtml),

  /** @see getShareableCreditNotePdf */
  getShareableCreditNotePdf: wrapMethod(getShareableCreditNotePdf),

  /** @see getShareableCreditNoteEslog */
  getShareableCreditNoteEslog: wrapMethod(getShareableCreditNoteEslog),

  /** @see createCreditNote */
  create: wrapMethod(createCreditNote),

  /** @see getCreditNotes */
  list: wrapListMethod(getCreditNotes),

  /** @see createCustomCreditNote */
  createCustom: wrapMethod(createCustomCreditNote),

  /** @see getCreditNoteById */
  get: wrapMethod(getCreditNoteById),

  /** @see updateCreditNote */
  update: wrapMethod(updateCreditNote),

  /** @see getCreditNoteVersions */
  getVersions: wrapMethod(getCreditNoteVersions),

  /** @see getCreditNoteVersion */
  getVersion: wrapMethod(getCreditNoteVersion),

  /** @see renderCreditNotePreview */
  renderCreditNotePreview: wrapMethod(renderCreditNotePreview),

  /** @see voidCreditNote */
  void: wrapMethod(voidCreditNote),
} as const;

export type CreditNotesApi = typeof creditNotes;
